export default "__VITE_ASSET__t47XmqaN__"